import { webapi } from '@/api/webapi.ts';
import { cancelAlgo } from '@/store/orders/algoOrders/api/cancelAlgo.ts';
import { fillNowAlgo } from '@/store/orders/algoOrders/api/fillNowAlgo.ts';
import { pauseAlgo } from '@/store/orders/algoOrders/api/pauseAlgo.ts';
import { resumeAlgo } from '@/store/orders/algoOrders/api/resumeAlgo.ts';
import { submitAlgo } from '@/store/orders/algoOrders/api/submitAlgo.ts';
import { updateAlgo } from '@/store/orders/algoOrders/api/updateAlgo.ts';
import { validateAlgo } from '@/store/orders/algoOrders/api/validateAlgo.ts';

export const algoOrderApi = webapi.injectEndpoints({
  endpoints: (builder) => ({
    validateAlgo: validateAlgo(builder),
    submitAlgo: submitAlgo(builder),
    updateAlgo: updateAlgo(builder),
    cancelAlgo: cancelAlgo(builder),
    pauseAlgo: pauseAlgo(builder),
    resumeAlgo: resumeAlgo(builder),
    fillNowAlgo: fillNowAlgo(builder),
  }),
});

export const {
  useValidateAlgoMutation,
  useSubmitAlgoMutation,
  useCancelAlgoMutation,
  usePauseAlgoMutation,
  useResumeAlgoMutation,
  useFillNowAlgoMutation,
  useUpdateAlgoMutation,
} = algoOrderApi;
